import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    kpiId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiItem.getTable, {
        kpiId,
    }, options);
    if (error) return { error, status };
    return content ||
        {
            rows: [],
            info: {},
            rules: {
                edit: false,
                audit: false,
                remove: false,
                publish: false,
                submit: false,
                cancelAudit: false,
                auditLogs: false,
            },
        };
};
